module.exports = __webpack_public_path__ + "img/ticket.0278fe35.svg";